const API_BASE_URL = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

let sessionExpiredHandler = null;

export const setSessionExpiredHandler = (handler) => {
  sessionExpiredHandler = handler;
};
export const authenticatedFetch = async (url, options = {}) => {
  const token = localStorage.getItem('jwtToken');
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };

  const fetchOptions = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, fetchOptions);
    if (response.status === 401) {
      const data = await response.json().catch(() => ({}));
      
      if (data.sessionExpired) {
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('user');
        localStorage.removeItem('role');
        if (sessionExpiredHandler) {
          sessionExpiredHandler(data.message || 'Your session has expired');
        }
        
        throw new Error(data.message || 'Session expired');
      }
    }
    
    return response;
  } catch (error) {
    throw error;
  }
};

export const apiCall = async (endpoint, options = {}) => {
  const url = endpoint.startsWith('http') ? endpoint : `${API_BASE_URL}${endpoint}`;
  return authenticatedFetch(url, options);
};